import { useState } from "react";
import ImageModal from "./AlMahaDrive/ImageModal";
import styled from "styled-components";

interface Props {
  imgSrc: string;
  width: string;
  height: string;
}

const ImageClickModal = ({ imgSrc, width, height }: Props) => {
  const [openImageModal, setOpenImageModal] = useState(false);

  const handleImageModal = () => {
    setOpenImageModal(true);
  };

  const handleClose = () => {
    setOpenImageModal(false);
  };
  return (
    <>
      <StyledImg
        src={imgSrc}
        alt="imag-doc"
        width={width}
        height={height}
        onClick={handleImageModal}
      />
      <ImageModal
        onClose={handleClose}
        open={openImageModal}
        imageLink={imgSrc}
      />
    </>
  );
};

const StyledImg = styled.img`
  cursor: pointer;
`;

export default ImageClickModal;
